import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService } from '../services/data-service/data.service';
import {TokenKeys} from "../token.keys";
import {ApiRequests} from "../api.routes";

@Injectable()
export class HttpTenantInterceptor implements HttpInterceptor {
  constructor(private dataService: DataService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the request already has the 'Tenant' header
    const hasTenantHeader = req.headers.has('TenantData');

    // Skip adding headers for login requests
    if (req.url.includes(ApiRequests.Login)) {
      return next.handle(req);
    }

    // Retrieve token and connection strings
    const token = this.dataService.getUserToken();
    const tenantDataEnc = this.dataService.getValue(TokenKeys.TenantDataEnc) || 'tenant_data_enc';
    const userId = this.dataService.getValue(TokenKeys.userId) || 'tenant_data_enc';

    // Clone the request and set headers
    const modifiedReq = req.clone({
      setHeaders: {
        Authorization: token ? "Bearer " + token : '',
        accept: 'application/json',
        UserId: userId,
        // TenantData: tenantDataEnc,
        ...(req.headers.has('TenantData') ? {} : { TenantData: tenantDataEnc }),
      }
    });

    return next.handle(modifiedReq);
  }


  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   // Skip adding headers for login requests
  //   if (req.url.includes(ApiRequests.Login)) {
  //     return next.handle(req);
  //   }
  //
  //   // Retrieve token and connection strings
  //   const token = this.dataService.getUserToken();
  //   const tenantDataEnc = this.dataService.getValue(TokenKeys.TenantDataEnc) || 'tenant_data_enc';
  //   const userId = this.dataService.getValue(TokenKeys.userId) || 'tenant_data_enc';
  //
  //   // Clone the request and set headers
  //   const modifiedReq = req.clone({
  //     setHeaders: {
  //       Authorization: token ? "Bearer "+token : '',
  //       accept:'application/json',
  //       UserId: userId,
  //       TenantData: tenantDataEnc,
  //     }
  //   });
  //
  //   return next.handle(modifiedReq);
  // }
}
